import React, { useState, useEffect,useCallback } from 'react';
import { Typography, Box, FormControl, Select, MenuItem } from '@mui/material';
import ItemGrid from '../common/ItemGrid';
import CatlogCard from './CatlogCard';
import CatlogListView from './CatlogListView';
import { learnerService } from '../../services/api';
import { useEmbedded } from '../../hooks/useEmbedded';
import { useEmbedParams } from '../../hooks/useEmbedParams';
import LoadingSkeleton from '../common/LoadingSkeleton';
const Catlog = () => {
  const [learnings, setLearnings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [typeFilter, setTypeFilter] = useState('all');
  const isEmbedded = useEmbedded();
  const embedParams = useEmbedParams();

    // Custom fetch function for ItemGrid
  const fetchItems = useCallback(async (page, limit, searchTerm, sortOrder) => {
  const [sortField, sortDirection] = sortOrder ? sortOrder.split(' ') : ['created_at', 'DESC'];
  const response = await learnerService.getCatlog({
    page,
    limit,
    search: searchTerm,
    type: typeFilter,
    sortField: sortField === 'title' ? 'name' : sortField,
    sortDirection
  });

  const filteredData = response.data?.data || [];
  const pagination = response.data?.pagination || { page: 1, limit, total: filteredData.length };
  const totalPages = Math.ceil(pagination.total / pagination.limit);
  const hasMore = pagination.page < totalPages;

  return {
    data: {
      sortedItems: filteredData,
      courses: typeFilter !== 'paths' ? filteredData.filter(item => item.type === 'course') : [],
      lpaths: typeFilter !== 'courses' ? filteredData.filter(item => item.type === 'learning path') : [],
      job_aids:typeFilter !== 'courses' && typeFilter!== 'paths' ? filteredData.filter(item=>item.type=== 'job aid') : [],
      certificates:typeFilter !== 'courses' && typeFilter!== 'paths' && typeFilter!== 'jobAid' ? filteredData.filter(item=>item.type=== 'certificate') : [],
      pagination: {
        total: pagination.total,
        hasMore
      }
    }
  };
}, [typeFilter]); // <-- Add typeFilter as dependency

  useEffect(() => {
    fetchCatlog();
  }, []);

  const fetchCatlog = async () => {
    try {
      setLoading(true);
      const response = await learnerService.getCatlog();
      // setLearnings(response.data || []);
      setLearnings(response.data?.data || []);

    } catch (err) {
      console.error('Error fetching my learnings:', err);
      setError('Failed to load your learning activities. Please try again later.');
    } finally {
      setLoading(false);
    }
  };

  // Filter learnings based on active filter
  const filteredLearnings = learnings.filter(item => {
    if (typeFilter === 'all') return true;
    if (typeFilter === 'courses') return item.type === 'course';
    if (typeFilter === 'paths') return item.type === 'learning path';
    //if (typeFilter === 'jobAid') return item.type === 'job aid';
    //if (typeFilter === 'certificates') return item.type === 'certificate';
    return true;
  });

  if (loading) {
    return <LoadingSkeleton rows={6} />;
  }

  if (error) {
    return (
      <Box sx={{ textAlign: 'center', p: 4, color: 'error.main' }}>
        <Typography variant="h6">{error}</Typography>
      </Box>
    );
  }   

  const CustomFilterComponent = () => {    
    // Hide type filter if embed setting is disabled
    if (isEmbedded && embedParams.hideMlTypeFilter) {
      return null;
    }

    return (
      <FormControl 
        sx={{
          minWidth: 200,
          maxWidth: 250,
          height: 35,
          '& .MuiInputBase-root': {
            height: 35,
            padding: '0 8px',
            fontSize: '14px',
            display: 'flex',
            alignItems: 'center',
          },
          '& .MuiSelect-select': {
          padding: '5px 10px', 
          },
        }}
      >
        <Select
          value={typeFilter}
          onChange={(e) => { 
            setTypeFilter(e.target.value);
            if (e.target.value !== typeFilter) {
              // This will trigger a re-fetch with the new filter
              const event = new CustomEvent('resetItemGrid');
              window.dispatchEvent(event);
            }
          }}
          className="pink-filter"
          displayEmpty
        >
          <MenuItem value="all">All Types</MenuItem>
          <MenuItem value="courses">Courses</MenuItem>
          <MenuItem value="paths">Learning Paths</MenuItem>
          {/* <MenuItem value="job aid">Job Aids</MenuItem>
          <MenuItem value="certificates">Certificate</MenuItem> */}
        </Select>
      </FormControl>
    );
  };
  return (
    <div className="catalog-filters-wrapper">
      <ItemGrid
        title="Catalog"
        // description="View and continue your enrolled courses and learning paths."
        itemType={
        typeFilter === 'courses'
          ? 'course'
          : typeFilter === 'paths'
          ? 'learningPath'
          : typeFilter === 'jobAid'
          ? 'job aid'
          : typeFilter === 'certificates'
          ? 'certificate'
          : 'all'
        }
        fetchItems={fetchItems}
        ItemCardComponent={CatlogCard}
        ItemListComponent={CatlogListView}
        createPermission=""
        createPath=""
        filterOptions={true}
        authorFilterEnabled={false}
        CustomFilterComponent={CustomFilterComponent}
        isEmbedded={isEmbedded}
        showSortingFilter={isEmbedded ? !embedParams.hideMlSortingFilter : true}
        showViewToggle={isEmbedded ? !embedParams.hideMlGridList : true}
        embedParams={embedParams}
        //onClearFilters={() => window.dispatchEvent(new CustomEvent('resetItemGrid'))}
        hasActiveCustomFilters={typeFilter !== 'all'}
        onClearFilters={() => setTypeFilter('all')}
      />
    </div>
  );
};

export default Catlog;